import clsx from 'clsx';
import React, { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import { SectionTitleBase } from './SectionTitleBase.component';

export { SectionTitleBase as SectionTitle };

interface SectionProps {
  className?: string;
  children: ReactNode;
  noPadding?: boolean;
}

const Section: React.FC<SectionProps> = ({ className, children, noPadding }) => (
  <section className={twMerge(clsx('rounded-2xl bg-white', !noPadding && 'px-6 pt-4 pb-6 md:px-12 md:pt-12 md:pb-12', className))}>
    {children}
  </section>
);

export default Section;
